export default () =>
  import(/* webpackChunkName: 'coffee/app/live-video' */ './LiveVideo');
